import { render, staticRenderFns } from "./ElementPointTableColumn.vue?vue&type=template&id=74fbdee2&scoped=true"
import script from "./ElementPointTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementPointTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementPointTableColumn.vue?vue&type=style&index=0&id=74fbdee2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fbdee2",
  null
  
)

export default component.exports